import { render } from "./ConfigurationIndexEdit.vue?vue&type=template&id=61fc7c4e"
import script from "./ConfigurationIndexEdit.vue?vue&type=script&lang=js"
export * from "./ConfigurationIndexEdit.vue?vue&type=script&lang=js"

import "./ConfigurationIndexEdit.vue?vue&type=style&index=0&id=61fc7c4e&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__